module.exports = __webpack_public_path__ + "static/img/site-2.10d5902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/site-2.png
// module id = LQj8
// module chunks = 0